import PropTypes from 'prop-types'

import channelsProps from './channels'

export default {
    id: PropTypes.string,
    mac: PropTypes.string,
    api_url: PropTypes.string,
    socket_url: PropTypes.string,
    sync_url: PropTypes.string,
    store_code: PropTypes.string,
    store_location: PropTypes.shape({
        id: PropTypes.number,
        slug: PropTypes.string,
        name: PropTypes.string,
    }),
    volume: PropTypes.string,
    layer_enabled: PropTypes.string,
    screen_rotation: PropTypes.string,
    background_colour: PropTypes.string,
    selected_channel: PropTypes.string,
    sync_offset: PropTypes.string,
    sync_delay: PropTypes.string,
    sync_timeout: PropTypes.string,
    working_open: PropTypes.string,
    working_close: PropTypes.string,
    layer_extra: PropTypes.string,
    channels: PropTypes.arrayOf(PropTypes.shape(channelsProps)),
}
